// src/components/Layouts/ChannelModalLayout.jsx
import React from 'react';
import { createPortal } from 'react-dom';
import CommonModalLayout from './CommonModalLayout';

const ChannelModalLayout = ({ isOpen, onClose, title, children }) => {
    return (
        <CommonModalLayout isOpen={isOpen} onClose={onClose} title={title}>
            {children}
        </CommonModalLayout>
    );
};

export default ChannelModalLayout;
